import {
  Button,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
  Table,
  Spinner,
} from "reactstrap";
import HeaderAdmin from "../../../components/HeaderAdmin/HeaderAdmin";
import "./styles.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ptBR } from "date-fns/locale";
import { useContext, useEffect, useState, useCallback } from "react";
import { Context } from "../../../hooks/useAuthContext";
import api from "../../../services/axiosConfig";
import { format } from "date-fns";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import PaginationComponent from "../../../components/PaginationComponent/PaginationComponent";
import { Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

function Logs() {
  const { exibirLogs } = useContext(Context);

  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedAuthor, setSelectedAuthor] = useState("");

  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [logs, setLogs] = useState([]);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  const [sortField, setSortField] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("desc");

  const fetchUsers = useCallback(async () => {
    try {
      const response = await api.get("/admin/users-painel");
      if (Array.isArray(response.data.users)) {
        setUsers(response.data.users);
      }
    } catch (error) {
      exibirLogs && console.error("Erro ao buscar usuários:", error);
    }
  }, [exibirLogs]);

  async function fetchLogs(isSearchButton = false) {
    // Se a busca veio do botão, reseta para a página 1
    const currentPage = isSearchButton ? 1 : page;
    if (isSearchButton) {
      setPage(1);
    }

    setLoading(true);
    try {
      const params = {
        page: currentPage,
        limit,
        sortField,
        sortOrder,
      };

      if (selectedAuthor) {
        params.autor = selectedAuthor;
      }
      if (selectedDate) {
        params.dataCriacao = format(selectedDate, "yyyy-MM-dd");
      }

      const response = await api.get("/logs", { params });
      setLogs(response.data.data);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      exibirLogs && console.error("Erro ao buscar logs:", error);
      // ...
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  useEffect(() => {
    fetchLogs();
  }, [page, sortField, sortOrder]);

  const handleSearch = () => {
    fetchLogs(true); // Passa `true` para indicar que é uma nova busca
  };

  const handleSort = (field) => {
    const newSortOrder =
      sortField === field && sortOrder === "asc" ? "desc" : "asc";
    setSortField(field);
    setSortOrder(newSortOrder);
    setPage(1);
  };

  return (
    <div>
      <HeaderAdmin />
      <div className="infoPage">
        <span>
          <Link to={'/'} style={{ textDecoration: 'none', color: '#000'}}>
            <FaArrowLeft size={16} /> Logs do Sistema
          </Link> 
        </span>
      </div>
      <div className="miniWrapper usuariosContainer" style={{ marginTop: 25 }}>
        <Row>
          <Col md={3} sm={6} xs={12}>
            <FormGroup className="filterGroup">
              <Label for="date-filter">Data:</Label>
              <DatePicker
                id="date-filter"
                selected={selectedDate}
                onChange={(date) => setSelectedDate(date)}
                dateFormat="dd/MM/yyyy"
                locale={ptBR}
                className="dateInputDash"
                placeholderText="Selecione uma data"
                autoComplete="off"
                isClearable
              />
            </FormGroup>
          </Col>

          <Col md={3} sm={6} xs={12}>
            <FormGroup className="filterGroup">
              <Label for="selectUsers">Usuários</Label>
              <Input
                id="selectUsers"
                name="select"
                type="select"
                value={selectedAuthor}
                onChange={(e) => setSelectedAuthor(e.target.value)}
              >
                <option value="">Todos</option>{" "}
                {users?.map((user) => (
                  <option key={user._id} value={user.nome}>
                    {user.nome}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>

          <Col md={2} sm={6} xs={12}>
            <FormGroup className="filterGroup">
              <Label>Ação</Label>
              <Button
                color="secondary"
                onClick={handleSearch}
                disabled={loading}
              >
                {loading ? <Spinner size="sm" /> : "Buscar"}
              </Button>
            </FormGroup>
          </Col>
        </Row>

        <Table striped bordered responsive>
          <thead>
            <tr>
              <th
                style={{ cursor: "pointer" }}
                onClick={() => handleSort("autor")}
              >
                Autor{" "}
                {sortField === "autor" &&
                  (sortOrder === "asc" ? <IoIosArrowDown /> : <IoIosArrowUp />)}
              </th>
              <th>Tela</th>
              <th>Atividade</th>
              <th
                style={{ cursor: "pointer" }}
                onClick={() => handleSort("createdAt")}
              >
                Data{" "}
                {sortField === "createdAt" &&
                  (sortOrder === "asc" ? <IoIosArrowDown /> : <IoIosArrowUp />)}
              </th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="4" className="text-center">
                  <Spinner>Carregando...</Spinner>
                </td>
              </tr>
            ) : logs?.length > 0 ? (
              logs.map((log) => (
                <tr key={log._id}>
                  <td>{log.autor}</td>
                  <td>{log.tela}</td>
                  <td>{log.atividade?.join(", ")}</td>
                  <td>
                    {format(new Date(log.createdAt), "dd/MM/yyyy HH:mm:ss")}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="text-center">
                  Nenhum log encontrado para os filtros selecionados.
                </td>
              </tr>
            )}
          </tbody>
        </Table>

        {totalPages > 1 && (
          <PaginationComponent
            currentPage={page}
            totalCount={totalPages * limit}
            pageSize={limit}
            onPageChange={(p) => setPage(p)}
            loading={loading}
          />
        )}
      </div>
    </div>
  );
}

export default Logs;
